import React from 'react';
import { Link } from 'react-router-dom';
import BookAssessment from './BookAssessment';

const SECONDARY_CLASS =
  'inline-flex min-h-[44px] items-center justify-center rounded-md border border-gray-700 px-6 py-3 text-base font-medium text-gray-300 transition-colors duration-150 hover:border-gray-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950';

interface CTASectionProps {
  placement?: string;
  // Absent on page-level routes, which have no modal in scope and are better served by
  // the real /contact URL anyway. The homepage keeps the modal for in-page clicks.
  onOpenContactModal?: () => void;
}

const CTASection: React.FC<CTASectionProps> = ({ onOpenContactModal, placement = 'closing' }) => {
  return (
    <div id="book" className="border-t border-gray-800 bg-gray-950 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:flex lg:items-end lg:justify-between lg:gap-12">
        <div className="max-w-measure">
          <h2 className="font-display text-display-md sm:text-display-lg font-bold text-white">
            Tell us what your team keeps doing by hand.
          </h2>
          <p className="mt-4 text-lg text-gray-400">
            Thirty minutes, no charge. You leave with an honest read on whether it is worth automating.
          </p>
        </div>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row lg:mt-0 lg:flex-shrink-0">
          <BookAssessment placement={placement} variant="bare" band="gray-950" />
          {onOpenContactModal ? (
            <button onClick={onOpenContactModal} className={SECONDARY_CLASS}>
              Send a message
            </button>
          ) : (
            <Link to="/contact" className={SECONDARY_CLASS}>
              Send a message
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default CTASection;
